export default "__VITE_ASSET__Ba8dQnXr__"